import { render } from "./RecordsViewTitle.vue?vue&type=template&id=0b9b731f"
import script from "./RecordsViewTitle.vue?vue&type=script&lang=js"
export * from "./RecordsViewTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__